// extracted by mini-css-extract-plugin
export default {"commonLayout":"pd","spanHeader":"qd"};